import { userAgent } from '@seiue/ua'
import { Table } from 'antd'
import styled, { CSSProperties } from 'styled-components'

export const BoardCard = styled.div<{ $flex?: number }>`
  display: flex;
  flex-direction: column;
  flex: ${({ $flex }) => $flex};
  padding: 12px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  gap: 4px;
`

export const Title = styled.div`
  font-size: 18px;
  font-weight: 600;
  line-height: 24px;
  color: ${({ theme }) => theme.text._1};
`

export const H1 = styled.div<{ $reverse?: boolean }>`
  font-size: 40px;
  font-weight: bold;
  line-height: 48px;
  color: ${({ theme }) => theme.text._1};
`

export const H2 = styled.div`
  font-size: 32px;
  font-weight: bold;
  line-height: 40px;
`

export const H3 = styled.div<{ $reverse?: boolean }>`
  font-size: 28px;
  font-weight: 500;
  line-height: 30px;
  color: ${({ theme }) => theme.text._1};
`

export const H4 = styled.div`
  font-size: 24px;
  font-weight: bold;
  line-height: 32px;
  color: ${({ theme }) => theme.text._1};
`

export const H5 = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 26px;
  color: ${({ theme }) => theme.text._1};
`

export const H6 = styled.div`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: ${({ theme }) => theme.text._1};
`

export const Label = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.text._2};
  flex-shrink: 0;
`

export const BoldLabel = styled(Label)`
  font-weight: 500;
`

export const MainLabel = styled(Label)`
  font-weight: 500;
  color: ${({ theme }) => theme.text._1};
`

export const SubLabel = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.text._1};
`

export const TipLabel = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: ${({ theme }) => theme.text._2};
`

export const FlexBaseline = styled.div`
  display: flex;
  align-items: baseline;
  gap: 2px;
`

export const EmptyWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Flex = styled.div<{
  $gap?: number
  $flex?: number
  $width?: CSSProperties['width']
  $align?: CSSProperties['alignItems']
  $justify?: CSSProperties['justifyContent']
}>`
  display: flex;
  align-items: ${({ $align }) => $align || 'center'};
  gap: ${({ $gap }) => $gap ?? 8}px;
  flex: ${({ $flex }) => $flex};
  width: ${({ $width }) => $width};
  justify-content: ${({ $justify }) => $justify};
`

export const FlexVertical = styled(Flex)`
  flex-direction: column;
  align-items: ${({ $align }) => $align || 'flex-start'};
`

export const StyledTable = styled(Table)<{ $total: number }>`
  &&& {
    .ant-table-tbody
      > tr.ant-table-row.even-row:not(.ant-table-row-selected)
      td {
      background-color: ${(props) => props.theme.background._4};
    }

    .ant-table-content {
      background-color: ${(props) => props.theme.background._4};
    }
    .ant-table-thead > tr > th {
      background-color: ${(props) => props.theme.background._4};
    }
    .ant-table-thead > tr > th:first-child {
      border-left: 1px solid ${(props) => props.theme.border.greyNormal};
    }
    .ant-table-tbody > tr.ant-table-row.even-row:hover td {
      background: transparent;
    }
    .ant-table {
      height: ${({ $total }) =>
        // windows 的滚动条会占用 15px
        $total * 43 +
        15 +
        (userAgent.os.name === 'Windows' && window.innerWidth < 1600
          ? 15
          : 0)}px;
      margin: 0 !important;
      margin-left: 101px !important;
    }
    .ant-table-row > td:first-child {
      border-left: 1px solid ${(props) => props.theme.border.greyNormal};
    }
    .ant-table-tbody > tr:last-child > td {
      border-bottom: 1px solid ${(props) => props.theme.border.greyNormal} !important;
    }
    .ant-table-row > .ant-table-cell {
      height: 43px;
    }
  }
`

export const ListWrapper = styled.div`
  &&& {
    .ant-table-wrapper {
      border: none;
    }
    .ant-table-expanded-row-fixed {
      background-color: ${(props) => props.theme.background._4};
      padding: 0;
    }
    .ant-table-expanded-row > .ant-table-cell {
      padding: 16px 0 0 0 !important;
      /* 保证展开行高度足够，避免固定列布局下与下一行重叠（340 内容 + 上下内边距） */
      min-height: 376px;
    }
    .ant-table-row-expand-icon {
      border-color: #d9d9d9;
    }
  }
`

export const Tips = styled.div`
  display: flex;
  align-items: center;
  padding: 9px 16px;
  gap: 8px;
  background-color: #e8f5ff;
  width: 100%;
  margin-bottom: 16px;
  border-radius: 8px;
`

export const TipsLabel = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: ${({ theme }) => theme.text._1};
`
